angular.module("admin").factory("AdminClientsService", ["$rootScope", "$http", "ENV", function ($rootScope, $http, ENV) {

	// référentiels disponible pour l'utilisateur courant
	$rootScope.currentUserReferentials = [];

	/**
	 * API
	 */
	return {
		addClient: addClient,
		deleteClient: deleteClient,
		editClient: editClient,
		editClientImportParameters: editClientImportParameters,
		editClientExportParameters: editClientExportParameters,
		getClient: getClient,
		getAllClients: getAllClients,
		eraseClientData: eraseClientData,
		anonymizeClientData: anonymizeClientData,
		initSimulation: initSimulation,
		editModuleAccessibilities: editModuleAccessibilities,
		resetSimulation: resetSimulation,
		startResetWhiteList: startResetWhiteList,
		startScriptScheduled: startScriptScheduled,
		startScriptDay: startScriptDay,
		startScriptFix: startScriptFix,
		getReferentialId: getReferentialId,
		getReferentialName: getReferentialName,
		getReferentialIdFromSimulation: getReferentialIdFromSimulation,
		getParentReferentialId: getParentReferentialId,
		getUser: getUser,
		getReferentialIdAndUser: getReferentialIdAndUser,
		getReferentielIdAndUserForSimulation: getReferentielIdAndUserForSimulation,
		getProvider: getProvider,
		getClientModuleAccessibilitites: getClientModuleAccessibilitites,
		getCurrentReferential: getCurrentReferential,
		getCurrentUserClients: getCurrentUserClients,
		refreshUserClients: refreshUserClients,
		watchUserClients: watchUserClients,
		getCurrentClient: getCurrentClient
	};

	function eraseClientData(clientId) {
		return $http.get(ENV.API_URL + "/admin/technical/deleteData/client/" + clientId);
	}

	function anonymizeClientData(clientId) {
		return $http.get(ENV.API_URL + "/admin/technical/anonymize-personal-information/client/" + clientId);
	}

	function startResetWhiteList(clientId) {
		return $http.get(ENV.API_URL + "/fiti/whitelist/client/" + clientId + "/rebuild");
	}

	function startScriptScheduled() {
		return $http.get(ENV.API_URL + "/scheduled/start/night");
	}

	function startScriptFix() {
		return $http.get(ENV.API_URL + "/scheduled/start/fix");
	}

	function startScriptDay() {
		return $http.get(ENV.API_URL + "/scheduled/start/day");
	}

	/**
	 * Retourne tous les clients.
	 * @returns {HttpPromise}
	 */
	function getAllClients(withoutDefaultClient) {
		return $http.get(ENV.API_URL + "/admin/clients?withoutDefaultClient=" + withoutDefaultClient);
	}

	/**
	 * Mettre à jour un client.
	 * @param client
	 * @returns {*|HttpPromise}
	 */
	function editClient(client) {
		return $http.put(ENV.API_URL + "/admin/clients/" + client.id, client);
	}

	function editClientImportParameters(client) {
		return $http.put(ENV.API_URL + "/admin/clients/" + client.id + "/importParameters", client);
	}

	function editClientExportParameters(client) {
		return $http.put(ENV.API_URL + "/admin/clients/" + client.id + "/exportParameters", client);
	}


	/**
	 * Récupérer un client par son ID.
	 *
	 * @param id l'Id du client à récupérer.
	 * @returns {*}
	 */
	function getClient(id) {
		return $http.get(ENV.API_URL + "/admin/clients/" + id);
	}

	/**
	 * Supprimer un client.
	 *
	 * @param client le client à supprimer.
	 * @returns {HttpPromise|*|{display}}
	 */
	function deleteClient(client) {
		return $http.delete(ENV.API_URL + "/admin/clients/" + client.id);
	}


	/**
	 * Poster un client vers le serveur.
	 * @param client
	 * @returns {*|HttpPromise}
	 */
	function addClient(client) {
		return $http.post(ENV.API_URL + "/admin/clients", client);
	}

	/**
	 * Initialise un espace de simulation
	 * @returns {Promise<*>}
	 */
	function initSimulation(client) {
		return $http.post(ENV.API_URL + "/admin/clients/simulation/new", client, getUser());
	}

	/**
	 * Update module accessibilities for client
	 */
	function editModuleAccessibilities(client, isTopologyActivated, areDisruptionsActivated) {
		return $http.post(ENV.API_URL + "/admin/clients/editModuleAccessibilities?isTopologyActivated=" + isTopologyActivated + "&areDisruptionsActivated=" + areDisruptionsActivated, client);
	}

	/**
	 * Get module accessibilities for client
	 */
	function getClientModuleAccessibilitites(id) {
		return $http.get(ENV.API_URL + "/admin/clients/getClientModuleAccessibilities/" + id);
	}

	/**
	 * Réinitialise les données d'un espace de simulation
	 * @returns {Promise<*>}
	 */
	function resetSimulation(client) {
		return $http.post(ENV.API_URL + "/admin/clients/simulation/reset", client, getUser());
	}

	async function getCurrentClient() {
		const clients = await getAllClients(false);
		return clients.data.find(e => e.code === window.sessionStorage.getItem("referential"));
	}

	async function getClientFromSimulation() {
		const clients = await getAllClients(false);
		const simulationRefName = window.sessionStorage.getItem("referential");
		return clients.data.find(e => e.code === simulationRefName.replace(/^simulation_/, ""));
	}

	/**
	 * Récupère le referential ID actuel
	 */
	async function getReferentialId() {
		const client = await getCurrentClient();
		const provider = await getProvider(client.code);
		return provider.id;
	}

	async function getReferentialName() {
		const client = await getCurrentClient();
		const provider = await getProvider(client.code);
		return provider.name;
	}

	async function getReferentialIdFromSimulation() {
		const client = await getClientFromSimulation();
		const provider = await getProvider(client.code);
		return provider.id;
	}

	/**
	 * Récupère le referential ID du super espace selon le referential ID actuel
	 */
	async function getParentReferentialId(refId) {
		let migrateDataToProvider = "";
		await $http.get(ENV.PROVIDERS_BASE_URL + refId).then((response) => {
			migrateDataToProvider = response.data.chouetteInfo.migrateDataToProvider;
		});
		return migrateDataToProvider;
	}


	async function getProvider(clientCode) {
		const provResp = await $http.get(ENV.PROVIDERS_BASE_URL);
		return provResp.data.find(p => p.name === clientCode || p.chouetteInfo.referential === clientCode);
	}

	/**
	 * Récupère l'utilisateur actuel
	 */
	async function getUser() {
		return window.localStorage.getItem("user");
	}

	/**
	 * Récupère le referential ID et l'utilisateur actuel
	 */
	async function getReferentialIdAndUser() {
		const refId = await getReferentialId(window.sessionStorage.getItem("referential"));
		return {
			id: refId, user: window.localStorage.getItem("user")
		};
	}

	/**
	 * Récupère l'id du référentiel dont est issu la simulation
	 */
	async function getReferentielIdAndUserForSimulation() {
		const refId = await getReferentialIdFromSimulation();
		return {
			id: refId, user: window.localStorage.getItem("user")
		};
	}

	function getCurrentReferential() {
		return window.sessionStorage.getItem("referential");
	}

	function getCurrentUserClients() {
		return $http.get(ENV.API_URL + "/admin/users/clients");
	}

	/**
	 * Met à jour la liste des référentiels disponibles/utilisables pour l'utilisateur courant
	 * @param updateCallback Fonction à appeler une fois la mise à jour effectuée
	 */
	function refreshUserClients(updateCallback) {
		getCurrentUserClients().then((response) => {
			const clients = response.data;
			// remove mosaic and simulation clients
			const clearedClients = clients.filter(c => c.code.indexOf("mobiiti_") !== 0)
										  .filter(c => c.code.indexOf("simulation_") !== 0);
			window.sessionStorage.setItem("referentials", JSON.stringify(clearedClients.map(c => c.code)));
			$rootScope.currentUserReferentials = clearedClients;
			if (updateCallback) {
				updateCallback(clearedClients);
			}
		});
	}

	/**
	 * "Ecoute" la variable globale $rootScrop.currentUserReferentials et exécute une fonction lorsque celle-ci change de valeur
	 */
	function watchUserClients(callback) {
		$rootScope.$watch("currentUserReferentials", callback);
	}

}]);